import { startTransition, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import { addToCart, buyNow } from "../../redux/action";
import { toast } from "react-toastify";
import { get, post } from "../../_services/apiService";
import { API_URL } from "../../_services/apiUrl";
import { customBodyType, customSizeHeight } from "../../_services/staticData";
import CustomSize from "./CustomSize";
import { FaChevronDown } from 'react-icons/fa';

const imageUrl = process.env.REACT_APP_IMAGE_BASE_URL

const DetailOfProduct = (props) => {
    const isFirstRender = useRef(true);
    const { productDetail, userAddress, GetProductDetailById } = props;
    const loginId = localStorage.getItem('loginId');
    const [loading, setLoading] = useState(false);
    const [size, setSize] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    // const cartData = useSelector((state) => state.cartReducer.cart) || [];
    const rawCartData = useSelector((state) => state.cartReducer.cart);

    const cartData = useMemo(() => rawCartData || [], [rawCartData]);

    const [selectedColorId, setSelectedColorId] = useState(productDetail?.productSkuDtos ? productDetail?.productSkuDtos[0]?.colorId : 0);
    const [selectedColorName, setSelectedColorName] = useState(null);
    const [filteredSku, setFilteredSku] = useState(null);
    // const skuId = localStorage.getItem('skuId');
    const [selectedHeight, setSelectedHeight] = useState(null);
    const [selectedBodyType, setSelectedBodyType] = useState(null);

    const [selectedSizeType, setSelectedSizeType] = useState(null);
    const [skuId, setSkuId] = useState(null);
    const [isOpen, setIsOpen] = useState(false);
    const params = useParams();
    const productId = params?.id;
    const [dropdownStates, setDropdownStates] = useState({
        isOpenSpecDropdown: false,
        isOpenMoreDropdown: false,
        isOpenReturnDropdown: false,
    });

    const toggleDropdown = (dropdown) => {
        setDropdownStates((prevState) => ({
            ...prevState,
            [dropdown]: !prevState[dropdown],
        }));
    };

    const cartQuantity = cartData.find(cartItem => Number(cartItem.productId) === Number(productId));

    const initialQuantity = cartQuantity ? cartQuantity.quantity + 1 : 1;

    const [formData, setFormData] = useState({
        skuId: 0,
        cartItemId: 0,
        productId: productId ? Number(productId) : 0,
        loginId: loginId ? Number(loginId) : 0,
        buyStatus: 1,
        quantity: initialQuantity,
        isActive: true,
        createdBy: 0,
        unitPrice: filteredSku?.salePrice || 0,
        totalAmount: filteredSku?.salePrice || 0,
        taxId: productDetail?.taxId || 0,
        taxAmount: productDetail?.taxAmount || 0
    });

    const [buyFormData, setBuyFormData] = useState({
        skuId: 0,
        cartItemId: 0,
        productId: productId ? Number(productId) : 0,
        loginId: loginId ? Number(loginId) : 0,
        buyStatus: 1,
        quantity: 1,
        isActive: true,
        createdBy: 0,
        unitPrice: filteredSku?.salePrice || 0,
        totalAmount: filteredSku?.salePrice || 0,
        taxId: productDetail?.taxId || 0,
        taxAmount: productDetail?.taxAmount || 0
    });

    const [customSizeForm, setCustomSizeForm] = useState({
        customReqId: 0,
        file: "",
        bodyType: "",
        loginId: loginId ? Number(loginId) : 0,
        productId: productId,
        breastSize: "",
        weistSize: "",
        hipSize: "",
        shoulder: "",
        armhole: "",
        height: "",
        remark: "",
        quantity: 1,
        requiredTime: null,
        address: "",
        isActive: true,
        createdBy: 0
    });

    // Function to toggle the popup open/close
    const togglePopup = () => {
        if (loginId) {
            setIsOpen(!isOpen);
            onResetCustom();
        } else {
            navigate('/login');
        }
    };

    const onResetCustom = () => {
        setCustomSizeForm({
            bodyType: "",
            customReqId: 0,
            loginId: loginId,
            productId: productId,
            breastSize: "",
            weistSize: "",
            hipSize: "",
            shoulder: "",
            armhole: "",
            height: "",
            remark: "",
            quantity: 1,
            requiredTime: null,
            address: "",
            isActive: true,
            createdBy: 0,
            file: ""
        });
        setSelectedHeight(null);
    }

    useEffect(() => {
        const firstActiveSize = size?.find((item) => item?.status === true);

        if (firstActiveSize) {
            setSelectedSizeType(firstActiveSize);
            setSkuId(firstActiveSize?.skuId);
        }
    }, [size, setSelectedSizeType]);

    const calculateDiscountPercent = (mrp, unitPrice) => {
        if (mrp && unitPrice && mrp > unitPrice) {
            return ((mrp - unitPrice) / mrp) * 100;
        }
        return 0;
    };

    const discountPercent = calculateDiscountPercent(filteredSku?.mrp || productDetail?.mrp, filteredSku?.salePrice || productDetail?.unitPrice);

    const onAddCart = async () => {
        sessionStorage.removeItem('customReqId');
        if (skuId === 0 || skuId === null) {
            alert('Please Select Size');
            return;
        }

        try {
            if (loginId) {
                await dispatch(addToCart(formData));
            } else {
                await dispatch(addToCart(formData, 1));
            }

            startTransition(() => {
                navigate('/cart');
            })
        } catch (error) {
            toast.error("Item not added in cart.");
        }
    };

    const onBuyNow = async () => {
        sessionStorage.removeItem("priviousUrl");

        if (skuId === 0 || skuId === null) {
            alert('Please Select Size');
            return;
        }

        try {
            await dispatch(buyNow(buyFormData));
            if (loginId) {
                // Pass the buyFormData to the buyNow function
                if (userAddress != null && userAddress.length > 0) {
                    localStorage.setItem('selectedAddressId', userAddress[0]?.addressId);
                    startTransition(() => {
                        navigate("/checkout");
                    })
                } else {
                    startTransition(() => {
                        navigate("/shipping-address");
                    })
                }
            } else {
                startTransition(() => {
                    navigate('/login')
                })
            }
        } catch (error) {
            toast.error("Failed to Buying Products");
        }
    };

    useEffect(() => {
        setFormData((prevData) => ({
            ...prevData,
            quantity: initialQuantity,
            unitPrice: filteredSku?.salePrice,
            totalAmount: filteredSku?.salePrice,
            taxId: productDetail?.taxId || 0,
            taxAmount: productDetail?.taxAmount || 0,
            buyStatus: 1
        }));

        setBuyFormData((prevData) => ({
            ...prevData,
            unitPrice: filteredSku?.salePrice,
            totalAmount: filteredSku?.salePrice,
            taxId: productDetail?.taxId || 0,
            taxAmount: productDetail?.taxAmount || 0,
            buyStatus: 1
        }));

    }, [cartData, initialQuantity, filteredSku, productDetail]);

    const GetProductSkuByProductColorId = useCallback(async (colorId) => {
        try {
            const url = `${API_URL.GetProductSkuByProductColorId}?ProductId=${productId}&ColorId=${colorId}`;

            const response = await get(url);

            if (response.isSuccess === 1) {
                setSize(response?.data);
            }
        } catch (error) {
            setSize([]);
        }
    }, [productId]);

    useEffect(() => {
        if (productId && isFirstRender.current) {
            GetProductSkuByProductColorId(productDetail.productSkuDtos ? productDetail?.productSkuDtos[0]?.colorId : 0);
            isFirstRender.current = false;
        }
    }, [productId, productDetail, GetProductSkuByProductColorId]);

    useEffect(() => {
        setFormData((prevFormData) => ({
            ...prevFormData,
            skuId: skuId || 0
        }));
    }, [skuId]);

    useEffect(() => {
        setBuyFormData((prevFormData) => ({
            ...prevFormData,
            skuId: skuId || 0
        }));
    }, [skuId]);

    const handleColorChange = (colorId, colorTypeName, skuId) => {
        setSelectedColorId(colorId);
        localStorage.setItem('colorId', colorId);
        localStorage.setItem('colorTypeName', colorTypeName);
        localStorage.setItem('skuId', skuId);
        GetProductSkuByProductColorId(colorId);
        GetProductDetailById();
        setSelectedSizeType(null);
        localStorage.removeItem('sizeTypeName');
        setSelectedColorName(colorTypeName);
    };

    const selectedSize = (item) => {
        setSelectedSizeType(item);
        setSkuId(item?.skuId);
        localStorage.setItem('skuId', item?.skuId);

        const filteredData = productDetail?.productSkuDtos?.find(
            (sku) => sku.sizeTypeId === item?.sizeTypeId
        );
        localStorage.setItem('sizeTypeName', item?.name);

        setFilteredSku(filteredData);
    };

    useEffect(() => {
        if (selectedSizeType?.sizeTypeId) {
            const filteredData = productDetail?.productSkuDtos?.find(
                (sku) => sku.sizeTypeId === selectedSizeType?.sizeTypeId
            );
            setFilteredSku(filteredData);
        }
    }, [selectedSizeType, productDetail?.productSkuDtos]);

    const handleHeightSelect = (selectedHeight) => {
        setCustomSizeForm((prevForm) => ({
            ...prevForm,
            height: selectedHeight,
        }));
        setSelectedHeight(selectedHeight);
    };

    const handleBodyTypeSelect = (selectedBodyType) => {
        setCustomSizeForm((prevForm) => ({
            ...prevForm,
            bodyType: selectedBodyType,
        }));
        setSelectedBodyType(selectedBodyType);
    };

    const handleChange = (e) => {
        const { name, value, files, type } = e.target;

        setCustomSizeForm(prevState => ({
            ...prevState,
            [name]: type === 'file' ? files[0] : value
        }));
    };

    const onSaveCustomSize = async (e) => {
        e.preventDefault();
        if (selectedBodyType === null) {
            alert('Please Select Body Type');
            return;
        }

        if (selectedHeight === "") {
            alert('Please Select Height');
            return;
        }

        setLoading(true);
        try {
            const response = await post(API_URL.SaveCustomOrder, customSizeForm, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });

            if (response.isSuccess === 200) {
                sessionStorage.setItem('customReqId', response?.data?.customReqId);
                toast.success("Your Request has been submitted successfully!");
                setSelectedBodyType(null);
                setSelectedHeight(null);
                onResetCustom();
                togglePopup();
                onBuyNow();
            }
        } catch (error) {
            toast.error("Your Request has been Failed.");
        }
        finally {
            setLoading(false);
        }
    };

    return (
        // <div className="col-lg-7 scroll_product_content">
        <>
            <div className="col-lg-7">
                <div className="product_wpeer mt-sm-auto mt-3">
                    <h2>{productDetail?.displayName}</h2>
                    <p className="short_description" dangerouslySetInnerHTML={{ __html: productDetail?.shortDesc }} />
                    <div className="price_inner">
                        {filteredSku ? (
                            <>
                                <p className="unitPrice">₹{filteredSku?.salePrice} </p>
                                <del>₹{filteredSku?.mrp}</del>
                            </>
                        ) : (
                            <>
                                <p className="unitPrice">₹{productDetail?.unitPrice} </p>
                                <del>₹{productDetail?.mrp}</del>
                            </>
                        )

                        }

                        {discountPercent > 0 && (
                            <span className="discount_percent mb-0"><p className="discount_persent_amount">{`${discountPercent.toFixed(0)}% off`} </p><p className="mb-0 Inclusive">Inclusive of all taxes</p></span>
                        )}
                        {/* <p className="mb-0" style={{ paddingLeft: '8px', fontSize: '16px' }}>{productDetail?.stockStatus ? '(In Stock)' : '(Out of Stock)'} </p> */}
                    </div>

                    <div className="mt-3">
                        <div className="color_wrapper">
                            <p className="mb-1 cdfg_ud">
                                Color: <span className="selected_color_name capitalize">{selectedColorName || (productDetail?.productSkuDtos?.length > 0 ? productDetail.productSkuDtos[0]?.colorName : "No color available")}</span>
                            </p>
                            <div className="color_circle">
                                {productDetail?.productSkuDtos?.length > 0 &&
                                    Array.from(
                                        new Set(
                                            productDetail?.productSkuDtos?.map(item => item.colorCode || item.colorName)
                                        )
                                    ).map((color, index) => {
                                        const colorId = productDetail?.productSkuDtos?.find(item =>
                                            item?.colorName === color || item?.colorCode === color
                                        )?.colorId;

                                        const colorName = productDetail?.productSkuDtos?.find(item =>
                                            item?.colorName === color || item?.colorCode === color
                                        )?.colorName;

                                        const skuId = productDetail?.productSkuDtos?.find(item =>
                                            item?.colorName === color || item?.colorCode === color
                                        )?.skuId;

                                        const isFilteredColor = selectedColorId &&
                                            productDetail?.productSkuDtos?.some(item =>
                                                item.colorId === selectedColorId && (item?.colorName === color || item?.colorCode === color)
                                            );

                                        const filteredProductSkuDtos = colorId
                                            ? productDetail?.productSkuDtos?.filter(item => item.colorId === colorId)
                                            : productDetail?.productSkuDtos;

                                        return (
                                            <div
                                                key={index}
                                                className={`color_box curser-pointer product-item ${isFilteredColor ? 'colorfiltered' : ''}`}
                                                // style={{
                                                //     backgroundColor: color, // Use color as background
                                                // }}
                                                onClick={() => handleColorChange(colorId, colorName, skuId)}
                                            >
                                                <span className="color_images_filter">
                                                    <img
                                                        src={`${imageUrl}${filteredProductSkuDtos[0]?.productImageDtos[0]?.imgPath}`}
                                                        alt={`Color preview for ${colorName}`}
                                                        onError={(e) => {
                                                            e.target.style.display = 'none';
                                                            e.target.closest('.color_box').style.backgroundColor = color;
                                                        }}
                                                    />

                                                </span>
                                            </div>

                                        );
                                    })
                                }
                            </div>
                        </div>

                        <div className="size_wepper">
                            <div className="size_flex">
                                <p className="mb-1 cdfg_ud">Size : <span>{selectedSizeType?.name}</span></p>
                            </div>
                            {size?.length > 0 &&
                                <div className="color_wrapper d-sm-flex align-items-center mt-2">
                                    <div className="size_circle">
                                        {size?.map((item, index) => {
                                            const isSelected = selectedSizeType?.sizeTypeId === item?.sizeTypeId;

                                            return (
                                                <div
                                                    key={index}
                                                    className={`size_box curser-pointer product-item ${!item?.status ? 'status' : ''} ${isSelected ? 'selected' : ''}`}
                                                    onClick={() => item?.status && selectedSize(item)}
                                                >
                                                    <span>{item?.name}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                    <div className="sc_lihm mt-sm-0 mt-3">
                                        <Link to='/sizechart' title="sizechart" className="d-flex align-items-center gap-1">
                                            <p className="mb-0 mt-0">Size Chart</p>
                                            <img src="./images/sizechart.svg" alt="" />
                                        </Link>
                                    </div>
                                </div>
                            }
                        </div>
                        {productDetail?.isCustom && selectedSizeType ? (
                            <CustomSize
                                isOpen={isOpen}
                                togglePopup={togglePopup}
                                customSizeForm={customSizeForm}
                                setCustomSizeForm={setCustomSizeForm}
                                onSaveCustomSize={onSaveCustomSize}
                                loading={loading}
                                customSizeHeight={customSizeHeight}
                                handleChange={handleChange}
                                handleHeightSelect={handleHeightSelect}
                                selectedHeight={selectedHeight}
                                customBodyType={customBodyType}
                                selectedBodyType={selectedBodyType}
                                setSelectedBodyType={setSelectedBodyType}
                                handleBodyTypeSelect={handleBodyTypeSelect}
                            />
                        ) : null}
                    </div>

                    <div className="delivery_date mt-2">
                        <>
                            {productDetail?.stockStatus === false ? (
                                <>
                                    <button
                                        className="web_buttons"
                                        disabled
                                        aria-disabled="true"
                                    >
                                        Add to Cart
                                    </button>
                                    <button
                                        className="web_buttons"
                                        disabled
                                        aria-disabled="true"
                                    >
                                        Buy Now
                                    </button>
                                </>
                            ) : (
                                <>
                                    <button
                                        className="web_buttons"
                                        onClick={() => onAddCart(productDetail)}
                                    >
                                        Add to Cart
                                    </button>
                                    <button
                                        className="web_buttons"
                                        onClick={() => onBuyNow()}
                                    >
                                        Buy Now
                                    </button>
                                </>
                            )}
                        </>
                        <hr />
                    </div>

                    <div className="dropdown_detaile_section">
                        <div className="line_devider_spec mt-4"></div>
                        <div className="specification_dropdown_wrapper">
                            <div
                                className="specification_dropdown_heading"
                                onClick={() => toggleDropdown("isOpenSpecDropdown")}
                            >
                                <span>Product Details</span>
                                <FaChevronDown
                                    className={`rotate-icon ${dropdownStates.isOpenSpecDropdown ? "open" : ""}`}
                                />
                            </div>
                            <div
                                className={`pt-0 pragaraf_content specification_dropdown_content ${dropdownStates.isOpenSpecDropdown ? "open" : ""
                                    }`}
                            >
                                {productDetail?.productSpecificationDtos?.map((item, i) => (
                                    <div
                                        className="d-flex w-100 justify-content-center my-0 pragaraf_inner_content"
                                        key={i}
                                    >
                                        <p className="col-sm-3 col-6 mb-sm-auto mb-0">
                                            <strong>{item?.specificationDisplayName} :</strong>
                                        </p>
                                        <p className="col-sm-9 col-6">{item?.description}</p>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="line_devider_spec"></div>
                        <div className="specification_dropdown_wrapper">
                            <div className="specification_dropdown_heading" onClick={() => toggleDropdown("isOpenMoreDropdown")}>
                                <span>More Information</span>
                                <FaChevronDown className={`rotate-icon ${dropdownStates.isOpenMoreDropdown ? "open" : ""}`} />
                            </div>
                            <div className={`pt-0 pragaraf_content specification_dropdown_content ${dropdownStates.isOpenMoreDropdown ? "open" : ""}`}>
                                <div className="d-flex w-100 justify-content-center pragaraf_inner_content">
                                    <p className="short_description" dangerouslySetInnerHTML={{ __html: productDetail?.displayDesc }} />
                                </div>
                            </div>
                        </div>
                        <div className="line_devider_spec"></div>
                        <div className="specification_dropdown_wrapper">
                            <div className="specification_dropdown_heading" onClick={() => toggleDropdown("isOpenReturnDropdown")}>
                                <span>Return and Exchange Policy</span>
                                <FaChevronDown className={`rotate-icon ${dropdownStates.isOpenReturnDropdown ? "open" : ""}`} />
                            </div>
                            <div className={`pt-0 pragaraf_content specification_dropdown_content ${dropdownStates.isOpenReturnDropdown ? "open" : ""}`}>
                                <div className="">
                                    <p className="col-sm-9 col-12"><b>7-Day Easy Returns & Exchanges!</b> We offer a hassle-free, no-questions-asked return and exchange policy within India for 7 days from the date of delivery.</p>
                                </div>
                            </div>
                        </div>
                        <div className="line_devider_spec"></div>
                    </div>
                </div>
            </div >
        </>
    )
}

export default DetailOfProduct;